import React, { useEffect, useState } from 'react';
import { Collapse, Input, Modal, message, DatePicker } from 'antd';
import styles from './VideoListStyle.module.scss';
import "./VideoListStyle.scss";
import { fetchWebsiteCardsCount } from '../../actions';
import { useDispatch } from 'react-redux';
import { changeTheVideoLimit } from '../../services/cardsService';
import { errorToast } from '../../api/Util';
import moment from 'moment';
import {applyMiddleware, createStore} from "redux";
import reduxThunk from "redux-thunk";
import { FETCH_SUB_DOMAIN_DATA } from "../../actions/types";
import reducers from "../../reducers";
import { axiosClient } from "../../api/httpClient";

const VideoListForm = ({setDomainData}) => {
  const dispatch = useDispatch();
  const store = createStore(reducers, {}, applyMiddleware(reduxThunk));
  const webData = JSON.parse(localStorage.getItem('subDomainData'));
  const [videoLimit, setVideoLimit] = useState(webData?.total_allowed_videos_count);
  const [launchDate, setLaunchDate] = useState(webData?.launch_date || null);

  const handleChanges = async () => {
    const payload = {};
    if (videoLimit >= 8 && videoLimit <= 500) {
      payload.videoLimit = videoLimit;
    } else if (videoLimit) {
      message.error("Video limit must be between 8 and 500");
      return;
    }

    if (launchDate) {
      payload.launchDate = launchDate;
    }

    if (Object.keys(payload).length > 0) {
      const response = await changeTheVideoLimit(payload);
      if (response.status) {
        message.success("Changes saved successfully.");
        dispatch(fetchWebsiteCardsCount());

        // Fetch and set subdomain data
        axiosClient.get('/api/white-label-customer-info/' + window.location.host)
          .then(response => {
            store.dispatch({ type: FETCH_SUB_DOMAIN_DATA, payload: response });
            localStorage.setItem('subDomainData', JSON.stringify(response?.data));
            setDomainData(response?.data);
          }).catch(err => {
            console.error(err);
            store.dispatch({ type: FETCH_SUB_DOMAIN_DATA, payload: err.response });
          });
      } else {
        errorToast("Failed to save changes.");
      }
    } else {
      message.error("No valid changes to save.");
    }
  };

  return (
    <div>
      <Collapse className="custom-collapse" expandIconPosition="end" defaultActiveKey={['1']}>
        <Collapse.Panel header="Video Limit Settings" key="1">
          <div className={styles.videoLimitForm}>
            <div className={styles.videoLimitDiv}>
              <label className={styles.videoLimitLabel}>Change Video Limit</label>
              <Input
                type="number"
                value={videoLimit}
                min={8}
                max={500}
                onChange={(e) => {
                  setVideoLimit(Number(e.target.value));
                }}
                placeholder="Video Limit"
                className={styles.videoLimitInput}
              />
            </div>
            <div className={styles.videoLimitDiv}>
              <label className={styles.videoLimitLabel}>Launch Date</label>
              <DatePicker
                value={launchDate ? moment(launchDate, 'YYYY-MM-DD') : null}
                format="YYYY-MM-DD"
                onChange={(date, dateString) => {
                  setLaunchDate(dateString);
                }}
                placeholder="Select Launch Date"
                className={styles.videoLimitInput}
              />
            </div>
            <button
              className={styles.submitBtn}
              onClick={() => {
                Modal.confirm({
                  title: "Are you sure?",
                  content: `Do you want to save the changes? Video Limit: ${videoLimit || 'No Change'}, Launch Date: ${launchDate || 'No Change'}`,
                  okText: "Yes",
                  cancelText: "No",
                  onOk: () => {
                    handleChanges();
                  },
                });
              }}
            >
              Submit
            </button>
          </div>
        </Collapse.Panel>
      </Collapse>
    </div>
  );
};

export default VideoListForm;
